import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter, useStore } from './store';
// FORK_PATCH_BEGIN: account-public-id — normalize account route identifiers
import { normalizeAccountIdentifier } from 'dashboard/helper/accountIdentifier';
// FORK_PATCH_END: account-public-id

/**
 * Composable for account-related operations.
 * @returns {Object} An object containing account-related properties and methods.
 */
export function useAccount() {
  /**
   * FORK_PATCH_BEGIN: account-public-id
   * Computed property for the current public account identifier.
   * @type {import('vue').ComputedRef<string>}
   * FORK_PATCH_END: account-public-id
   */
  const route = useRoute();
  const store = useStore();
  const getAccountFn = useMapGetter('accounts/getAccount');
  const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  // FORK_PATCH_BEGIN: account-public-id — preserve the compatible accountId API
  const accountId = computed(() =>
    normalizeAccountIdentifier(route.params.accountId)
  );
  const accountIdentifier = accountId;
  // FORK_PATCH_END: account-public-id
  const currentAccount = computed(() => getAccountFn.value(accountId.value));

  /**
   * Generates an account-scoped URL.
   * @param {string} url - The URL to be scoped to the account.
   * @returns {string} The account-scoped URL.
   */
  const accountScopedUrl = url => {
    return `/app/accounts/${accountId.value}/${url}`;
  };

  const isCloudFeatureEnabled = feature => {
    // FORK_PATCH_BEGIN: account-public-id
    return isFeatureEnabledonAccount.value(accountId.value, feature);
    // FORK_PATCH_END: account-public-id
  };

  const accountScopedRoute = (name, params, query) => {
    return {
      name,
      params: { accountId: accountId.value, ...params },
      query: { ...query },
    };
  };

  const updateAccount = async (data, options) => {
    await store.dispatch('accounts/update', {
      ...data,
      options,
    });
  };

  return {
    accountId,
    // FORK_PATCH_BEGIN: account-public-id
    accountIdentifier,
    // FORK_PATCH_END: account-public-id
    route,
    currentAccount,
    accountScopedUrl,
    accountScopedRoute,
    isCloudFeatureEnabled,
    isOnChatwootCloud,
    updateAccount,
  };
}
